import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import {postSubmit, isEmpty, scrollToComponent, stringToDate, formatDate, FORMAT_DATE_BACK} from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { evolutionDataFilters } from "../../../@signals"


export default function useShareOfSearchEvolutionData() {
	const { showToast } = useAppToast()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const chartColors = useSignal({})
	const skuName = useSignal("")
    const dateRange = useSignal([])
	const isLoadingDataEvolution = useSignal(false)

    useEffect(() => {
		if (!isEmpty(evolutionDataFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${WEBBACK_V2_API}/share-of-search/keyword-details/evolution`, evolutionDataFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chart
				dataEvolutionKeys.value = res.chartKeys
				chartColors.value = res.chartColors
				skuName.value = res.skuName
                dateRange.value = [stringToDate(evolutionDataFilters.value.startDate), stringToDate(evolutionDataFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-chart')))
		}) 

		if (isEmpty(evolutionDataFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			chartColors.value = {}
			skuName.value = ""
		})

	}, [JSON.stringify(evolutionDataFilters.value)]);

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            evolutionDataFilters.value = {
                ...evolutionDataFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		chartColors.value = {}
		skuName.value = ""
		evolutionDataFilters.value = {}
		scrollToComponent('table-details')
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		chartColors: chartColors.value,
		skuName: skuName.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}